import {
  Box,
  Button,
  CircularProgress,
  Grid,
  InputLabel,
  makeStyles,
  TextField,
  useTheme,
  useMediaQuery
} from '@material-ui/core';
import Autocomplete from '@material-ui/lab/Autocomplete';
import { green } from '@material-ui/core/colors';
import React, { useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { STATUS_API } from 'src/app/constant/config';

import { Formik } from 'formik';
import { vehicleType } from 'src/app/constant/vehicleType';
import {
  activeDevice,
  getUsernameByPhoneNumber,
  resetSearchUsernameByPhone
} from 'src/features/deviceSlice';
import * as Yup from 'yup';
import CustomDialog from 'src/app/components/CustomDialog';
import Switch from '@material-ui/core/Switch';
import { getListUsers } from 'src/features/userSlice';
import { getListCustomer } from 'src/features/customerSlice';

const BuzzerSwitch = ({ checked, ...props }) => {
  const classes = useStyles();

  return (
    <Box className={classes.buzzerSwitchWrapper}>
      <span className={classes.buzzerSwitchText}>
        {checked ? 'Tắt' : 'Bật'}
      </span>
      <Switch
        checked={checked}
        classes={{
          root: classes.buzzerSwitchRoot,
          switchBase: classes.buzzerSwitchBase,
          thumb: classes.buzzerSwitchThumb,
          track: classes.buzzerSwitchTrack
        }}
        {...props}
      />
    </Box>
  );
};

const ActiveDevice = ({ open, onClose, dataSelected }) => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const statusActive = useSelector(state => state.deviceSlice.statusActive);
  const username = useSelector(state => state.deviceSlice.username);
  const isAdmin = useSelector(state => state.authSlice.isAdmin);
  const isCustomerCare = useSelector(state => state.authSlice.isCustomerCare);
  const canListUsers = isAdmin || isCustomerCare;
  const listUsers = useSelector(state => state.userSlice.listUsers);
  const isUserLoading = useSelector(state => state.userSlice.isLoading);
  const listCustomer = useSelector(
    state => state.customerSlice.listCustomer
  );
  const isCustomerLoading = useSelector(state => state.customerSlice.isLoading);
  const [deviceTypeDetail, setDeviceTypeDetail] = useState({});
  const [selectedTonnage, setSelectedTonnage] = useState([]);
  const [selectedSlots, setSelectedSlots] = useState([]);
  const [selectedPhone, setSelectedPhone] = useState('');
  const [configAlert, setConfigAlert] = useState(
    dataSelected?.is_turn_on_sound || false
  );
  const [configAcc, setConfigAcc] = useState(true);
  const [formKey, setFormKey] = useState(0);
  const formikRef = useRef(null);
  const validationSchema = Yup.object().shape({
    vehicle_license_plate: Yup.string()
      .max(100)
      .matches(
        /^[A-Z0-9]+$/,
        'Chỉ nhập chữ in hoa và số, không chứa ký tự đặc biệt'
      )
      .required('Biển số không được để trống'),
    title_device_type: Yup.string().required(
      'Loại phương tiện không được để trống'
    ),
    phone: Yup.string()
      .matches(
        /^(84|0[3|5|7|8|9])+([0-9]{8})$/,
        'Số điện thoại chưa đúng định dạng'
      )
      .required('Số điện thoại không được để trống')
  });
  const searchTimeout = useRef(null);

  useEffect(() => {
    setConfigAlert(dataSelected?.is_turn_on_sound || false);
  }, [dataSelected, open]);

  useEffect(() => {
    if (canListUsers) {
      dispatch(
        getListUsers({
          page: 1,
          page_size: 5,
          keywords: ''
        })
      );
      return;
    }

    dispatch(
      getListCustomer({
        page: 1,
        page_size: 5,
        keywords: ''
      })
    );
  }, [dispatch, canListUsers]);

  const handleSubmit = data => {
    if (data && data.serial) {
      const dataActive = {
        phone: selectedPhone,
        full_name: username ? username : '',
        serial: data?.serial,
        version: data?.version,
        vehicle_license_plate:
          deviceTypeDetail?.id !== 1 ? data.vehicle_license_plate : null, // do tên người với biển số xe đang dùng chung 1 Textfield
        title_device_type: deviceTypeDetail?.name ? deviceTypeDetail.name : '',
        slots: data?.slots ? Number(data?.slots) : null,
        tonnage: data?.tonnage ? data?.tonnage : null,
        name_of_user_for_gps:
          deviceTypeDetail?.id === 1 ? data.vehicle_license_plate : null, // do tên người với biển số xe đang dùng chung 1 Textfield,
        sim_phone: data?.sim_phone ? data.sim_phone : null,
        is_turn_on_sound: configAlert,
        acc_status: configAcc ? 1 : 0
      };
      dispatch(activeDevice(dataActive));
      handleClose();
    }
  };

  const handleChangeAccSwitch = event => {
    setConfigAcc(event.target.checked);
  };

  const handleClose = () => {
    setSelectedPhone('');
    setDeviceTypeDetail({});
    setSelectedTonnage([]);
    setSelectedSlots([]);
    setConfigAlert(dataSelected?.is_turn_on_sound || false);
    setConfigAcc(true);
    setFormKey(prev => prev + 1);
    onClose();
  };

  const trim = x => {
    return x.replace(/^\(+|\)+$/gm, '');
  };

  const handleSelectVehicle = (e, value, setFieldValue) => {
    const target = vehicleType.find(type => {
      return type.id === Number(value.id);
    });
    if (target) {
      setFieldValue('title_device_type', target.name);
      setDeviceTypeDetail(target);
      setSelectedSlots(target?.slots);
      setSelectedTonnage(target?.tonnage);
    }
  };

  const handleChangePhoneNumber = (value, setFieldValue) => {
    let searchData = trim(value || '');
    setSelectedPhone(searchData);
    setFieldValue('phone', searchData);
    if (searchData && searchData.length === 10) {
      dispatch(getUsernameByPhoneNumber({ phoneNumber: searchData }));
    }
  };

  const handleSearchUserActiveDevice = keywords => {
    if (searchTimeout.current) {
      clearTimeout(searchTimeout.current);
    }

    searchTimeout.current = setTimeout(() => {
      const searchParams = {
        page: 1,
        page_size: 5,
        keywords: keywords?.trim() || ''
      };

      if (canListUsers) {
        dispatch(getListUsers(searchParams));
        return;
      }

      dispatch(getListCustomer(searchParams));
    }, 500);
  };

  const getUserActiveDeviceOptionLabel = option => {
    if (typeof option === 'string') {
      return option;
    }

    const usernameLabel =
      option?.username || '';
    const phoneLabel = option?.phone || '';

    if (usernameLabel && phoneLabel) {
      return `${usernameLabel} - ${phoneLabel}`;
    }

    return usernameLabel || phoneLabel || '';
  };

  const userActiveDeviceOptions = canListUsers ? listUsers || [] : listCustomer || [];
  const isUserActiveDeviceLoading = canListUsers ? isUserLoading : isCustomerLoading;
  const isCarType = dataSelected?.deviceType?.name === 'VGPS_CAR4G';

  useEffect(() => {
    return () => {
      if (searchTimeout.current) {
        clearTimeout(searchTimeout.current);
      }
      dispatch(resetSearchUsernameByPhone());
    };
  }, [dispatch, isAdmin]);

  return (
    <CustomDialog title="Kích hoạt thiết bị" open={open} onClose={handleClose}>
      <div>
        <Formik
          key={formKey}
          innerRef={formikRef}
          enableReinitialize={true}
          initialValues={{
            phone: '',
            full_name: '',
            serial: dataSelected?.serial || '',
            title_device_type: '',
            vehicle_license_plate: '',
            version: dataSelected?.hardware_version || '',
            name_of_user_for_gps: '',
            tonnage: '',
            slots: '',
            device_type: dataSelected?.deviceType?.name || '',
            service_package:
              dataSelected?.deviceServicePackages?.servicePackage?.name || '',
            sim_phone: ''
          }}
          validationSchema={validationSchema}
          onSubmit={handleSubmit}
        >
          {({
            errors,
            handleBlur,
            handleChange,
            handleSubmit,
            touched,
            values,
            setFieldValue
          }) => (
            <form onSubmit={handleSubmit}>
              <Grid container spacing={3}>
                <Grid item md={6} xs={12}>
                  <InputLabel style={{ marginBottom: '21px' }}>
                    Tài khoản người dùng <span className="text-danger">*</span>
                  </InputLabel>
                  <Autocomplete
                    freeSolo
                    size="small"
                    fullWidth
                    style={{ marginTop: '-4px' }}
                    loading={isUserActiveDeviceLoading}
                    options={userActiveDeviceOptions}
                    getOptionLabel={getUserActiveDeviceOptionLabel}
                    inputValue={values.phone || ''}
                    value={
                      userActiveDeviceOptions.find(
                        option => option?.phone === values.phone
                      ) || values.phone
                    }
                    onChange={(e, value) => {
                      const selectedPhoneValue =
                        typeof value === 'string' ? value : value?.phone || '';
                      handleChangePhoneNumber(selectedPhoneValue, setFieldValue);
                    }}
                    onInputChange={(e, value, reason) => {
                      if (reason === 'input' || reason === 'clear') {
                        handleChangePhoneNumber(value, setFieldValue);
                        handleSearchUserActiveDevice(value);
                      }
                    }}
                    renderOption={option => getUserActiveDeviceOptionLabel(option)}
                    renderInput={params => (
                      <TextField
                        {...params}
                        name="phone"
                        variant="outlined"
                        className="input-no-fieldset"
                        onBlur={handleBlur}
                        error={Boolean(touched.phone && errors.phone)}
                        helperText={touched.phone && errors.phone}
                        InputProps={{
                          ...params.InputProps,
                          endAdornment: (
                            <>
                              {isUserActiveDeviceLoading ? (
                                <CircularProgress color="inherit" size={20} />
                              ) : null}
                              {params.InputProps.endAdornment}
                            </>
                          ),
                          style: {
                            fontSize: '16px',
                            padding: '0 8px',
                            height: '40px'
                          }
                        }}
                      />
                    )}
                    className={classes.customOutline}
                  />
                </Grid>
                <Grid item md={6} xs={12}>
                  <InputLabel>
                    Tên người dùng <span className="text-danger"></span>
                  </InputLabel>
                  <TextField
                    size="small"
                    disabled={true}
                    className="input-no-fieldset"
                    fullWidth
                    margin="normal"
                    name="full_name"
                    onBlur={handleBlur}
                    value={username}
                    variant="outlined"
                  />
                </Grid>
                <Grid item md={6} xs={12}>
                  <InputLabel>
                    Serial thiết bị <span className="text-danger"></span>
                  </InputLabel>
                  <TextField
                    disabled={true}
                    size="small"
                    className="input-no-fieldset"
                    fullWidth
                    margin="normal"
                    name="serial"
                    onBlur={handleBlur}
                    onChange={handleChange}
                    value={values.serial}
                    variant="outlined"
                  />
                </Grid>
                <Grid item md={6} xs={12}>
                  <InputLabel>
                    Loại thiết bị <span className="text-danger"></span>
                  </InputLabel>
                  <TextField
                    disabled={true}
                    size="small"
                    className="input-no-fieldset"
                    fullWidth
                    margin="normal"
                    name="serial"
                    onBlur={handleBlur}
                    onChange={handleChange}
                    value={values.device_type}
                    variant="outlined"
                  />
                </Grid>

                <Grid item md={6} xs={12}>
                  <InputLabel>
                    Số điện thoại Sim <span className="text-danger"></span>
                  </InputLabel>
                  <TextField
                    size="small"
                    className="input-no-fieldset"
                    fullWidth
                    margin="normal"
                    name="sim_phone"
                    onBlur={handleBlur}
                    onChange={handleChange}
                    value={values.sim_phone}
                    variant="outlined"
                  />
                </Grid>

                <Grid item md={6} xs={12}>
                  <InputLabel style={{ marginBottom: '21px' }}>
                    Loại phương tiện <span className="text-danger">*</span>
                  </InputLabel>
                  <Autocomplete
                    labelId="demo-simple-select-outlined-label"
                    id="demo-simple-select-outlined"
                    size="small"
                    options={vehicleType || []}
                    getOptionLabel={option => option.name}
                    value={
                      (vehicleType || []).find(
                        option => option.name === values.title_device_type
                      ) || null
                    }
                    onChange={(e, value) =>
                      handleSelectVehicle(e, value, setFieldValue)
                    }
                    disableClearable
                    renderInput={params => (
                      <TextField
                        {...params}
                        variant="outlined"
                        placeholder="Chọn loại phương tiện"
                        name="title_device_type"
                        error={Boolean(
                          touched.title_device_type && errors.title_device_type
                        )}
                        helperText={
                          touched.title_device_type && errors.title_device_type
                        }
                        InputProps={{
                          ...params.InputProps,
                          style: {
                            fontSize: '16px',
                            padding: '0 8px',
                            height: '35px'
                          }
                        }}
                      />
                    )}
                    className={classes.customOutline}
                  />
                </Grid>

                <Grid item md={6} xs={12}>
                  <InputLabel>
                    {deviceTypeDetail?.id !== 1 ? 'Biển số xe' : 'Tên người'}
                    <span className="text-danger"> *</span>
                  </InputLabel>
                  <TextField
                    size="small"
                    className="input-no-fieldset"
                    error={Boolean(
                      touched.vehicle_license_plate &&
                      errors.vehicle_license_plate
                    )}
                    fullWidth
                    helperText={
                      touched.vehicle_license_plate &&
                      errors.vehicle_license_plate
                    }
                    margin="normal"
                    name="vehicle_license_plate"
                    onBlur={handleBlur}
                    onChange={handleChange}
                    value={values.vehicle_license_plate}
                    variant="outlined"
                  />
                </Grid>

                <Grid item md={6} xs={12}>
                  <InputLabel>
                    Phiên bản <span className="text-danger"></span>
                  </InputLabel>
                  <TextField
                    disabled={true}
                    size="small"
                    className="input-no-fieldset"
                    fullWidth
                    margin="normal"
                    name="version"
                    onBlur={handleBlur}
                    onChange={handleChange}
                    value={values.version}
                    variant="outlined"
                  />
                </Grid>
                {deviceTypeDetail.id === 6 && (
                  <Grid item md={6} xs={12}>
                    <InputLabel>
                      Tải trọng <span className="text-danger">*</span>
                    </InputLabel>
                    <TextField
                      className="input-no-fieldset"
                      size="small"
                      fullWidth
                      select
                      margin="normal"
                      name="tonnage"
                      onBlur={handleBlur}
                      onChange={handleChange}
                      SelectProps={{
                        native: true
                      }}
                      value={values.tonnage}
                      variant="outlined"
                    >
                      <option>Chọn loại tải trọng</option>
                      {selectedTonnage &&
                        selectedTonnage.map(type => (
                          <option key={type.id} value={type.value}>
                            {type.name}
                          </option>
                        ))}
                    </TextField>
                  </Grid>
                )}

                {deviceTypeDetail.id === 4 && (
                  <Grid item md={6} xs={12}>
                    <InputLabel>
                      Số chỗ <span className="text-danger">*</span>
                    </InputLabel>
                    <TextField
                      className="input-no-fieldset"
                      size="small"
                      fullWidth
                      select
                      margin="normal"
                      name="slots"
                      onBlur={handleBlur}
                      onChange={handleChange}
                      SelectProps={{
                        native: true
                      }}
                      value={values.slots}
                      variant="outlined"
                    >
                      <option>Chọn số chỗ</option>
                      {selectedSlots &&
                        selectedSlots.map(type => (
                          <option key={type.id} value={type.value}>
                            {type.name}
                          </option>
                        ))}
                    </TextField>
                  </Grid>
                )}

                <Grid item md={6} xs={12}>
                  <InputLabel>
                    Gói dịch vụ <span className="text-danger"></span>
                  </InputLabel>
                  <TextField
                    disabled={true}
                    size="small"
                    className="input-no-fieldset"
                    fullWidth
                    margin="normal"
                    name="service_package"
                    onBlur={handleBlur}
                    onChange={handleChange}
                    value={values.service_package || '365D'}
                    variant="outlined"
                  />
                </Grid>

                {isCarType && (
                  <Grid
                    item
                    md={4}
                    xs={12}
                    className={classes.buzzerFieldWrapper}
                  >
                    <InputLabel className={classes.switchLabel}>
                      Cấu hình âm thanh cảnh báo
                      <span className="text-danger"></span>
                    </InputLabel>
                    <BuzzerSwitch
                      checked={configAlert}
                      onChange={e => setConfigAlert(e.target.checked)}
                      name="configAlert"
                    />
                  </Grid>
                )}
                <Grid
                  item
                  md={4}
                  xs={12}
                  className={classes.buzzerFieldWrapper}
                >
                  <InputLabel className={classes.switchLabel}>
                    Cấu hình ACC
                    <span className="text-danger"></span>
                  </InputLabel>
                  <BuzzerSwitch
                    checked={configAcc}
                    onChange={handleChangeAccSwitch}
                    name="configAcc"
                  />
                </Grid>
              </Grid>
              <Box my={3}>
                <div className={classes.groupButtonSubmit}>
                  <div className={classes.buttonGroup}>
                    <Button
                      style={{
                        ...(isMobile && { maxWidth: 90 }),
                        marginRight: '10px',
                        textTranform: 'none !important'
                      }}
                      onClick={handleClose}
                      className="btn-main btn-plain mx-3"
                      color="primary"
                      size="large"
                      variant="contained"
                    >
                      Thoát
                    </Button>
                    <Button
                      style={{
                        ...(isMobile && { maxWidth: 120 }),
                        marginRight: '10px',
                        textTranform: 'none !important'
                      }}
                      className="btn-main mx-3"
                      color="primary"
                      size="large"
                      type="submit"
                      variant="contained"
                    >
                      Kích hoạt
                    </Button>
                  </div>
                  {statusActive === STATUS_API.PENDING && (
                    <CircularProgress
                      size={24}
                      className={classes.buttonProgress}
                    />
                  )}
                </div>
              </Box>
            </form>
          )}
        </Formik>
      </div>
    </CustomDialog >
  );
};

const useStyles = makeStyles(theme => ({
  root: {
    minHeight: '100%',
    paddingBottom: theme.spacing(3),
    paddingTop: theme.spacing(3)
  },
  groupButtonSubmit: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    marginTop: '15px',
    position: 'relative'
  },
  buttonGroup: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center'
  },
  buttonProgress: {
    color: green[500],
    position: 'absolute',
    top: '50%',
    left: '50%',
    marginTop: -12,
    marginLeft: -12
  },
  customOutline: {
    '& .MuiOutlinedInput-notchedOutline': {
      borderWidth: '1px',
      borderColor: 'rgba(31, 31, 31, 0.14)',
      borderRadius: '4px'
    }
  },
  switchLabel: {
    marginRight: '16px',
    marginBottom: '0 !important',
    fontSize: '14px',
    fontWeight: 500,
    color: 'rgba(0, 0, 0, 0.87)'
  },
  buzzerFieldWrapper: {
    display: 'flex',
    alignItems: 'center',
    marginTop: theme.spacing(2.5),
    [theme.breakpoints.down('sm')]: {
      marginTop: 0
    }
  },
  buzzerSwitchWrapper: {
    position: 'relative',
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    minWidth: 48
  },
  buzzerSwitchText: {
    position: 'absolute',
    left: 6,
    top: '50%',
    transform: 'translateY(-50%)',
    fontSize: 10,
    fontWeight: 700,
    lineHeight: 1,
    color: '#ffffff',
    pointerEvents: 'none',
    zIndex: 1
  },
  buzzerSwitchRoot: {
    width: 48,
    height: 24,
    padding: 0,
    margin: 0
  },
  buzzerSwitchBase: {
    padding: 2,
    color: '#ffffff',
    '&.Mui-checked': {
      transform: 'translateX(24px)',
      color: '#ffffff',
      '& + $buzzerSwitchTrack': {
        backgroundColor: '#52d869',
        borderColor: '#52d869',
        opacity: 1
      }
    },
    '&.Mui-disabled + $buzzerSwitchTrack': {
      opacity: 0.7
    }
  },
  buzzerSwitchThumb: {
    width: 20,
    height: 20,
    borderRadius: 4,
    boxShadow: '0 1px 3px rgba(0, 0, 0, 0.25)'
  },
  buzzerSwitchTrack: {
    borderRadius: 4,
    backgroundColor: '#9e9e9e',
    border: '1px solid #9e9e9e',
    opacity: 1,
    transition: theme.transitions.create(['background-color', 'border-color'])
  }
}));

export default React.memo(ActiveDevice);
